function acceptLanguagePlugin({ opContext }) {
  opContext.headers["Accept-Language"] = window.Shopify?.locale || "fr";
}

export default acceptLanguagePlugin;
